import { useOktaAuth } from '@okta/okta-react'
import Button from '../../components/Button'

export default function OktaButton({ text = 'SSO' }: { text?: string }) {
  const { oktaAuth } = useOktaAuth()
  const login = async () => {
    oktaAuth.signInWithRedirect({ originalUri: '/' })
  }
  return (
    <Button
      text={text}
      variant="primary"
      size="medium"
      id="sso_button"
      onClick={login}
      data-cy="ssoButton"
    />
  )
}
